export { default } from '@adecco/base-app/pages/app';
